module.exports = __webpack_public_path__ + "images/help/video-ical-small-0782f1d6e282a0e380c037162c445f90.png";